import script from "./HrWorkforceAgeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceAgeTab.vue?vue&type=script&setup=true&lang=js"

import "./common/hrWorkforce.css?vue&type=style&index=0&id=0e4acfc4&scoped=true&lang=css"
import "./HrWorkforceAgeTab.vue?vue&type=style&index=1&id=0e4acfc4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e4acfc4"]])

export default __exports__